module.exports = __webpack_public_path__ + "img/transDots.c4f7c382.png";